import { render, staticRenderFns } from "./permisoDialog.vue?vue&type=template&id=02d7dcaa"
import script from "./permisoDialog.vue?vue&type=script&lang=js"
export * from "./permisoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports